@if (windowScrolled()) {
  <button
    class="button-up-btn"
    (click)="scrollTop()"
  ></button>
}
